import Masonry from '@/js/components/masonry';
import PinnedListWithImages from '@/js/components/animations/pinned_list_with_images';
import Swiper from 'swiper';

class Widget {
  constructor() {
    this.dom = {
      masonryTwoColumns: document.querySelectorAll('.js-masonry-two-columns'),
      pinnedLists: document.querySelectorAll('.l-widget--image-text-multiple'),
      partnerWidgets: document.querySelectorAll('.l-widget--partners'),
    };

    this.data = {
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.partner-next',
          prevEl: '.partner-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
        },
      },
    };

    this.components = {
      masonryTwoColumnsInstances: [],
      pinnedListsInstances: [],
      partnerSwiperInstances: [],
    };

    this.mount();
  }

  mount() {
    this.dom.masonryTwoColumns.forEach((container) => {
      this.components.masonryTwoColumnsInstances.push(new Masonry({ container }, 2));
    });

    if (this.dom.pinnedLists) {
      this.dom.pinnedLists.forEach((container) => {
        this.components.pinnedListsInstances.push(new PinnedListWithImages(container));
      });
    }

    if (this.dom.partnerWidgets) {
      this.initPartnerSwiper();
    }
  }

  initPartnerSwiper() {
    this.dom.partnerWidgets.forEach((widget) => {
      const swiperContainer = widget.querySelector('.partner-swiper');
      if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, this.data.swiperOptions);
        this.components.partnerSwiperInstances.push(swiper);
      }
    });
  }
}

if (document.querySelector('main.page-widget')) {
  // eslint-disable-next-line no-new
  new Widget();
}
